import { useEffect, useState } from "react";
import talTheme from "@tal-gel/theming-plugin-tal";
import AMPTheme from "@tal-gel/theming-plugin-amp";
import { Theme } from "@emotion/react";

const themeMap: Record<string, Theme> = {
  tal: talTheme,
  amp: AMPTheme,
};

const faviconMap: Record<string, string> = {
  tal: "/favicon.ico",
  amp: "/ampfavicon.ico",
};

export function useThemeSwitcher(): Theme {
  const pathSegment = window.location.pathname.split("/")[1];
  const fundKey = typeof pathSegment === "string" ? pathSegment.toLowerCase() : "";
  const initialThemeKey = fundKey && themeMap[fundKey] ? fundKey : "tal";

  const [themeKey, setThemeKey] = useState<string>(initialThemeKey);
  const [theme, setTheme] = useState<Theme>(themeMap[initialThemeKey]);

  useEffect(() => {
    const faviconHref = faviconMap[themeKey] || "./favicon.ico";
    let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "icon");
      document.head.appendChild(link);
    }
    link.setAttribute("href", faviconHref);

    setTheme(themeMap[themeKey]);
  }, [themeKey]);

  return theme;
}
